import React from "react";
import { Checkbox } from "../Checkbox";

export const FormCheckboxField = ({
  input: { value, ...inputProps },
  ...rest
}) => <Checkbox {...rest} {...inputProps} checked={value} />;
